import { Close, SaveOutlined } from '@mui/icons-material'
import { DialogActions, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'

type ConfigReviewDialogActionsProps = {
  isLoading?: boolean
  /** Shows the save buttons as busy while Cancel stays available */
  isSaveLoading?: boolean
  onCancel: () => void
  onSave: () => void
  onSaveAndRestart: () => void
  saveDisabled?: boolean
  /** Saving would replace a version someone else saved meanwhile, so the buttons say so */
  overwritesNewerVersion?: boolean
}

export function ConfigReviewDialogActions({
  isLoading,
  isSaveLoading = false,
  onCancel,
  onSave,
  onSaveAndRestart,
  saveDisabled = false,
  overwritesNewerVersion = false,
}: Readonly<ConfigReviewDialogActionsProps>) {
  const { t } = useTranslation()

  return (
    <DialogActions>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <CustomButton
          color="primary"
          disabled={isLoading || saveDisabled}
          loading={isSaveLoading}
          loadingPosition="start"
          startIcon={<SaveOutlined />}
          type="button"
          variant="contained"
          onClick={onSave}
        >
          {overwritesNewerVersion ? t('controllers.configuration.review_dialog.overwrite') : t('common.button.save')}
        </CustomButton>
        <CustomButton
          color="primary"
          disabled={isLoading || saveDisabled}
          loading={isSaveLoading}
          loadingPosition="start"
          startIcon={<SaveOutlined />}
          type="button"
          variant="contained"
          onClick={onSaveAndRestart}
        >
          {overwritesNewerVersion
            ? t('controllers.configuration.review_dialog.overwrite_and_restart')
            : t('controllers.configuration.review_dialog.save_and_restart')}
        </CustomButton>
        <CustomButton
          color="primary"
          disabled={isLoading}
          startIcon={<Close />}
          type="reset"
          variant="outlined"
          onClick={onCancel}
        >
          {t('common.button.cancel')}
        </CustomButton>
      </Stack>
    </DialogActions>
  )
}
